import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

export const loggedInGuard2: CanActivateFn = async () => {
    console.log('loggedInGuard2');
    return true;
};


/*
export const authGuard: CanActivateFn = async () => {
    const authService = inject(AuthService);
    const router = inject(Router);
    if (authService.isAuthenticated()) {
        return true;
    } else {
        await router.navigate(['/sign-in']);
        return false;
    }
};

export const loggedInGuard: CanActivateFn = async () => {
    const authService = inject(AuthService);
    if (!authService.isAuthenticated()) {
        return true;
    } else {
        await authService.redirectAfterLogin();
        return false;
    }
};

*/

export const anonGuard: CanActivateFn = async () => {
    const authService = inject(AuthService);
    const router = inject(Router);
    if (authService.isAnonymous()) {
        return true;
    } else {
        if (authService.isAuthenticated()) {
            await authService.redirectAfterLogin();
        } else {
            await router.navigate(['/bootstrap']);
        }
    }
    return false;
};

// TODO - MMD - implement adminGuard
export const adminGuard: CanActivateFn = async () => true;

export const tempGuard: CanActivateFn = async () => true;
